/* @flow */
import getJSONValue from '../utils/fields/getJSONValue';
import evaluateFunctionOrValue from '../utils/evaluateFunctionOrValue';
import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { isEqual, mapValues } from 'lodash';
import { connect } from 'react-redux';

/**
 * Map shared and appData values into a widget's config
 */
export default function withMappedWidgetConfig(component: Class<React$Component<*, *, *>>) {
  return connect(() => {
    const selectResolvedAppDataPaths = createSelectorCreator(defaultMemoize, isEqual)(
      (state, rawConfig, type, widgetId) => {
        const { appDataFieldPaths } = state.widgetFactory.loadMetaData(type);
        if (!appDataFieldPaths) {
          return {};
        }
        return mapValues(appDataFieldPaths, path => evaluateFunctionOrValue(path, state, rawConfig, widgetId));
      }, paths => paths);

    const selectAppData = createSelector(
      selectResolvedAppDataPaths,
      state => state.appData,
      (appDataFieldPaths, appData) => mapValues(appDataFieldPaths, path => getJSONValue(appData, path)));

    return createSelector(
      (state, props) => props.config,
      (state, props) => state.website.siteInfo.sharedConfigs[props.type],
      (state, props) => selectAppData(state, props.config, props.type, props.id),
      (rawConfig, shared, appData) => {
        return {
          config: {
            ...rawConfig,
            shared: {
              ...(rawConfig.shared || {}),
              ...shared
            },
            appData
          }
        };
      });
  })(component);
}



// WEBPACK FOOTER //
// ./~/nucleus-widgets/lib/withMappedWidgetConfig.js